import React from 'react'
import { motion } from 'framer-motion'
import PrimaryButton from '../../components/buttons/PrimaryButton'
import Close from '../../components/icons/Close'

const AvatarSuccess = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
      className="md:container mx-auto md:px-4 min-h-screen md:min-h-full"
    >
      <div className="bg-white p-8 w-full mx-auto rounded-lg shadow max-w-[648px] min-h-screen md:min-h-full">
        <div className="text-end">
          <a href="/" className="inline-block">
            <Close color="black" />
          </a>
        </div>
        <p className="text-3xl text-primary font-bold text-center mb-6">
          You're all set to make a difference
        </p>
        <p className="text-base font-normal text-center text-black mb-6">
          Your profile is complete and your avatar is ready. Now, embark on your
          journey of self-discovery and global impact in the MADverse.
        </p>
        <PrimaryButton className="w-full" to="/">
          Enter MAD Courses
        </PrimaryButton>
      </div>
    </motion.div>
  )
}

export default AvatarSuccess
